import React, { useEffect, useRef } from "react"
import { Animated } from "react-native"
import { style } from "./styles"

const AnimatedNewBadge = () => {
  const scaleAnim = useRef(new Animated.Value(0)).current

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(scaleAnim, {
          toValue: 1,
          duration: 500,
          useNativeDriver: true,
        }),
        Animated.timing(scaleAnim, {
          toValue: 0,
          duration: 500,
          useNativeDriver: true,
        }),
      ]),
    ).start()
  }, [])

  const scale = scaleAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [0.5, 0.8],
  })

  return (
    <Animated.Text
      style={[
        style.newBadgeText,
        {
          transform: [{ scale }, { rotate: "45deg" }],
          color: "red",
        },
      ]}
    >
      *NEW*
    </Animated.Text>
  )
}

export default AnimatedNewBadge
